import { Link } from 'Components/Core';
import { orderBy as deprecatedOrderBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetEditor';
import { FormatTypes, format } from '../../../../Lib/Format';
import { IconRestore, IconSnapshot } from '../../../../Lib/Icons';
import deepEquals from '../../../../Lib/Object/deepEquals';
import { Button, Dialog, Field, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { Grid } from '../../../Layout';
import './SnapshotDialog.scss';

/**
 * @deprecated Use ramda sortBy not lodash orderBy
 */
const sortBy = deprecatedOrderBy;

// Dialog letting users manage "snapshots" of worksheet data - that is, previously stored states of the worksheet model.
// This is an experimental, unfinished prototype to test how well our worksheets hold up when we restore old models.
let SnapshotDialog = ({ onClose, visible, namePrefix, ...otherProps }) => {
  const dispatch = useDispatch();
  const worksheetId = useSelector((state) => state.worksheetEditor.worksheetId);

  const snapshots = useSelector(
    (state) => sortBy(Object.values(state.worksheetEditor.snapshots), (r) => r.date, ['desc']),
    deepEquals
  );

  const latestSnapshotUpToDate = useSelector((state) =>
    deepEquals(
      state.worksheetEditor.syncModel,
      JSON.parse(localStorage.getItem(`${worksheetId}_snapshot_${snapshots[0]?.id}`)) || {}
    )
  );

  const applySnapshot = ({ id }) => {
    dispatch(actions.addSnapshot({ description: `Auto: Before revert to ${id.substr(0, 6)}` }));
    dispatch(actions.applySnapshot({ id, sync: true }));
    onClose();
  };

  const takeSnapshot = () => {
    dispatch(actions.addSnapshot({ description: 'Manual' }));
  };

  const removeSnapshot = ({ id }) => {
    dispatch(actions.removeSnapshot({ id }));
  };

  return (
    <>
      <Dialog
        {...otherProps}
        title="Worksheet Snapshots"
        width="800px"
        visible={visible}
        onClose={onClose}
        buttons={[
          latestSnapshotUpToDate && (
            <div className="SnapshotDialog-ButtonMessage" key="2">
              Latest snapshot up-to-date.
            </div>
          ),
          <Button primary key="1" onClick={takeSnapshot} disabled={latestSnapshotUpToDate}>
            <IconSnapshot /> Take Snapshot
          </Button>,
          <Button key="0" onClick={onClose}>
            Close
          </Button>,
        ]}
      >
        <span className="Message Message-warning">Experimental feature - use at own risk.</span>

        {snapshots.length > 0 ? (
          <Grid
            colHeaders={['Id', 'Date/Time', 'Description']}
            colWidths={[60, 180, 280, 180]}
            data={snapshots.map((s) => [
              <>
                <Link to={`/worksheets/${worksheetId}/snapshot/${s.id}`} openInNewTab>
                  {s.id.substr(0, 6)}
                </Link>
              </>,
              <Field
                input={<TextOutput />}
                value={format({
                  type: FormatTypes.DateTime,
                })(s.date)}
                label="Date/Time"
              />,
              <Field input={<TextOutput />} value={s.description} label="Description" />,
              <Button onClick={() => applySnapshot({ id: s.id })}>
                <IconRestore /> Revert to this snapshot
              </Button>,
            ])}
            onRemoveRow={(i) => removeSnapshot({ id: snapshots[i].id })}
          />
        ) : (
          <div className="SnapshotDialog-GridMessage">No snapshots have been taken.</div>
        )}
      </Dialog>
    </>
  );
};

SnapshotDialog = withInjectedProps(SnapshotDialog);

export { SnapshotDialog };
